import { render, staticRenderFns } from "./AlkDetails.vue?vue&type=template&id=058a1f89&scoped=true"
import script from "./AlkDetails.vue?vue&type=script&lang=js"
export * from "./AlkDetails.vue?vue&type=script&lang=js"
import style0 from "./AlkDetails.vue?vue&type=style&index=0&id=058a1f89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058a1f89",
  null
  
)

export default component.exports